/*
 * Formularios de contacto.
 *
 * Shopify recarga la pagina al enviar, asi que el aviso de confirmacion o
 * de error llega ya pintado en el HTML. Lo unico que falta es llevar el
 * foco hasta el: si no, quien navega con teclado o lector de pantalla no se
 * entera de que ha pasado algo.
 */

(function () {
  const aviso = document.querySelector('[data-reda-aviso]');
  if (!aviso) return;

  aviso.focus({ preventScroll: true });

  aviso.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'center',
  });
})();
